var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex map-container-height"},[_c('mapSidebar'),_c('b-tabs',{staticClass:"w-100 map-topbar"},[_c('b-tab',{attrs:{"title":"Map","active":""}},[_c('mapContent')],1),_c('b-tab',{attrs:{"title":"Graphs"}},[_c('mapGraphs')],1),_c('b-tab',{attrs:{"title":"tab"}},[_vm._v("something here")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }